import ReactDOM from "react-dom/client";
import dynamic from 'next/dynamic';
import OpenPopup from "./OpenPopup";

declare global {
    interface Window {
        openSignUpPopup: (section: any) => Promise<void>;
        openPopup: (section: any) => Promise<void>;
        handleCustomerRecentlyViewed: (card: any) => Promise<void>;
        getUserInfo: (arg1?: string, arg2?: boolean) => Promise<any>;
        getUserCustId: (arg1?: string, arg2?: boolean) => Promise<any>;
    }
}

if (typeof window !== "undefined") {
    window.openSignUpPopup = async (input: any) => {
        console.log('openSignUpPopup---------------------');

        const popupContainer = document.createElement('div');
        document.body.appendChild(popupContainer);

        const root = ReactDOM.createRoot(popupContainer);
        const closePopup = () => {
            root.unmount();
            document.body.removeChild(popupContainer);
        };

        // Partner signup flow — any type ending with "-register"
        if (input?.type && input.type.endsWith('-register')) {
            const SignUpPopup = dynamic(() => import('../signup_form/signupform'), { ssr: false });
            root.render(<SignUpPopup type={input?.type} onCloseHandler={closePopup} />);
            return;
        }

        // Real estate agent/broker signup form
        if (input?.type === 'real-estate') {
            const RealEstateSignupForm = dynamic(() => import('../signup_form/real_estate/RealEstateSignupForm'), {
                ssr: false,
            });
            root.render(<RealEstateSignupForm onCloseHandler={closePopup} />);
            return;
        }

        // Default signup popup
        const SignUpPopup = dynamic(() => import('../signup_form/signupform'), {
            ssr: false,
        });
        root.render(
            <SignUpPopup type={input?.type} onCloseHandler={closePopup} />
        );
    };
    window.openPopup = async (input: any) => {
        console.log('openPopup---------------------');
       
        const popupContainer = document.createElement('div');
        document.body.appendChild(popupContainer);

        const root = ReactDOM.createRoot(popupContainer);

        root.render(
            <OpenPopup sectionData={input} props={{}} />
        );
    }
    window.getUserCustId = async (arg1?: string, arg2: boolean = false) => {
        const userInfo = await window.getUserInfo(arg1, arg2);
        if (!userInfo || !userInfo.cId) {
            console.error('User info not available or customer ID is missing.');
            return null;
        }
        return userInfo.cId;
    };

    window.handleCustomerRecentlyViewed = async (card: any) => {
        if(window.getUserInfo === undefined) return;

        const userInfo = await window.getUserInfo("", true);
        if (!userInfo || !userInfo.cId) {
            console.error('User info not available or customer ID is missing.');
            return;
        }
        const recentlyViewedURL = `https://nestingale.com/v1/api/customer/recently-viewed?customerId=${userInfo.cId}&itemId=${card.id}&type=product`;

        try {
            console.log('Posting data to', recentlyViewedURL, 'to track customerRecentlyViewed');

            const response = await fetch(recentlyViewedURL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    customerId: userInfo.cId,
                    itemId: card.id,
                    type: 'product',
                    image: card.imageUrl,
                    name: card.name,
                    price: card.price,
                    comparePrice: card.comparePrice,
                    model3dUrl: card.model3dUrl || null,
                }),
            });

            if (!response.ok) {
                const errorDetails = await response.json(); // If server sends error details
                throw new Error(
                    `Error: ${response.status} - ${response.statusText}. Details: ${JSON.stringify(errorDetails)}`
                );
            }

            console.log('Successfully tracked recently viewed item:', card.id);
        } catch (error) {
            console.error('Error tracking recently viewed item:', error);
        }
    };
}